<!--  添加、编辑危废信息 -->
<template>
  <div class="addCheck">
    <el-drawer
      :title="form.id ? '修改' : '添加'"
      :visible.sync="userOpenFlag"
      @close="handleClose"
      @open="openMap"
      direction="rtl"
      size="40%"
    >
      <div class="demo-drawer__content">
        <div>
          <el-form
            :model="form"
            :rules="dwFormRules"
            ref="addDwForm"
            :label-position="'top'"
            size="small"
          >
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item
                  class="width-max"
                  label="危废名称"
                  prop="dangerWasterListId"
                >
                  <el-select
                    style="width: 100%"
                    disabled
                    v-model="form.dangerWasterListId"
                    filterable
                    placeholder="请选择危废名称"
                  >
                    <!-- @blur="$refs.addDwForm.validateField('tzCompanyId')"
                    @change="$refs.addDwForm.validateField('tzCompanyId')" -->
                    <el-option
                      v-for="item in wfList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  class="width-max"
                  label="是否跨省转移"
                  prop="isTransProvince"
                >
                  <span>{{ form.isTransProvince ? "是" : "否" }}</span>
                  <!-- <el-radio-group :disabled="true" v-model="form.isTransProvince">
    <el-radio :label="true">是</el-radio>
    <el-radio :label="false">否</el-radio> 
  </el-radio-group> -->
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item
                  class="width-max"
                  label="本年度计划产生量（吨）"
                  prop="yearPlanOutPut"
                >
                  <el-input
                    disabled
                    size="small"
                    readonly
                    v-model="form.yearPlanOutPut"
                    oninput="value=value.replace(/[^0-9.]/g,'')"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  class="width-max"
                  label="本年度计划处置量（吨）"
                  prop="yearPlanDisPosVol"
                >
                  <el-input
                    disabled
                    size="small"
                    readonly
                    v-model="form.yearPlanDisPosVol"
                    oninput="value=value.replace(/[^0-9.]/g,'')"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item
                  class="width-max"
                  label="处置单位"
                  prop="handleCompany"
                >
                  <!-- <el-input size="small" v-model="form.handleCompany"></el-input> -->

                  <el-select
                    style="width: 100%"
                    disabled
                    v-model="form.handleCompany.companyId"
                    placeholder="请选择处置方式"
                  >
                    <el-option
                      v-for="item in dealWithCompanies"
                      :key="item.companyId"
                      :label="item.name"
                      :value="item.companyId"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  class="width-max"
                  label="处置方式"
                  prop="handleType"
                >
                  <el-select
                    style="width: 100%"
                    disabled
                    v-model="form.handleType"
                    placeholder="请选择处置方式"
                  >
                    <el-option
                      v-for="item in handleType"
                      :key="item.value"
                      :label="item.name + ' ' + item.description"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item class="width-max" label="服务时间" prop="dates">
                  <el-date-picker
                    v-model="form.dates"
                    value-format="yyyy-MM-dd"
                    style="width: 100%"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="服务开始日期"
                    end-placeholder="服务结束日期"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item
                  class="width-max"
                  label="接受地"
                  prop="receptionPlaceArr"
                >
                  <el-cascader
                    size="small"
                    :options="pcTextArr"
                    v-model="form.receptionPlaceArr"
                  >
                  </el-cascader>
                  <!-- <el-input size="small" v-model="form.receptionPlace"></el-input> -->
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>
      <div class="demo-drawer__footer">
        <el-button type="primary" @click="saveData">保存</el-button>
        <el-button @click="userOpenFlag = false">取消</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { pcTextArr } from "element-china-area-data";
export default {
  name: "addDangerWaster",
  props: {
    wfList: {
      type: Array,
      default: [],
    },
    dealWithCompanies: {
      type: Array,
      default: [],
    },
    handleType: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      // selectedOptions: '临汾市',//['北京市', '通州区'],

      // pcTextArr,
      // palceProps: {
      //   emitPath: true,
      // },

      dwFormRules: {
        yearPlanOutPut: [
          {
            required: true,
            message: "请输入本年度计划产生量",
            trigger: "blur",
          },
        ],
        yearPlanDisPosVol: [
          {
            required: true,
            message: "请输入本年度计划处置量",
            trigger: "blur",
          },
        ],
        isTransProvince: [
          { required: true, message: "请选择是否跨省转移", trigger: "change" },
        ],
        handleCompany: [
          { required: true, message: "请输入处置单位", trigger: "blur" },
        ],
        handleType: [
          { required: true, message: "请选择处置方式", trigger: "change" },
        ],
        dangerWasterListId: [
          { required: true, message: "请选择危废名称", trigger: "change" },
        ],
        dates: [
          { required: true, message: "请选择服务时间", trigger: "change" },
        ],
        receptionPlaceArr: [
          {
            type: "array",
            required: true,
            message: "请选择接受地",
            trigger: "change",
          },
        ],
      },

      userOpenFlag: false,
      form: {
        dangerWasterList: "",
        dangerWasterListId: "",
        yearPlanOutPut: "",
        yearPlanDisPosVol: "",
        isTransProvince: "",
        receptionPlaceArr: [],
        receptionPlace: "",
        handleCompany: "",
        handleType: "",
        serviceStartDate: "",
        serviceEndDate: "",
        dates: [],
      },
    };
  },
  computed: {
    pcTextArr() {
      let result = this.$_.cloneDeep(pcTextArr);
      if (this.form.isTransProvince) {
        result.shift();
      } else {
        result = [result[0]];
      }
      return result;
    },
  },

  // watch:{
  //   'form.receptionPlaceArr': {
  //     handler(val) {

  //       if(val&&val.length>0){
  //         this.form.receptionPlace=val.join('-')
  //       }
  //     },
  //     deep: true,
  //     immediate: true
  //   }
  // },

  methods: {
    lookUserDrawerOpen(val) {
      //编辑
      if (val) {
        // let { s, ...enterpriseInfo } = val;
        let {
          serviceStartDate,
          serviceEndDate,
          dangerWasterList: { id },
        } = val;
        val.dangerWasterListId = id;
        if (serviceStartDate || serviceEndDate) {
          val.dates = [serviceStartDate, serviceEndDate];
        } else {
          val.dates = [];
        }
        val.receptionPlaceArr = val.receptionPlace
          ? val.receptionPlace.split("-")
          : [];
        this.form = this.$_.cloneDeep(val);
      } else {
        this.form = {
          dangerWasterList: "",
          dangerWasterListId: "",
          yearPlanOutPut: "",
          yearPlanDisPosVol: "",
          isTransProvince: "",
          receptionPlace: "",
          receptionPlaceArr: [],
          handleCompany: "",
          handleType: "",
          serviceStartDate: "",
          serviceEndDate: "",
          dates: [],
        };
      }
      this.userOpenFlag = true;
    },
    // 弹窗打开时初始化事件
    openMap() {
      this.$nextTick(() => {});
    },
    handleClose() {},
    saveData() {
      this.$refs.addDwForm.validate((valid) => {
        if (valid) {
          let { dangerWasterListId, dates } = this.form;
          this.form.dangerWasterList = { id: dangerWasterListId };
          if (dates && dates.length > 0) {
            this.form.serviceStartDate = dates[0];
            this.form.serviceEndDate = dates[1];
          }
          this.form.receptionPlace = this.form.receptionPlaceArr.join("-");

          let formData = this.form;
          let url = this.$api.dangerWasters.add;
          this.$axios.post(url, formData, false).then((res) => {
            if (res.data.code == 0) {
              this.$message({
                type: "success",
                message: res.data.msg,
              });
              this.$parent.getYearDangerWasters();
              this.userOpenFlag = false;
            } else {
              this.$message({
                type: "error",
                message: res.data.msg,
              });
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });

      // let formData = this.form;
      // let url = this.$api.tzSolids.tzSolids;
      // this.$axios.post(url, formData, false).then((res) => {
      //   if (res.data.code == 0) {
      //     this.$message({
      //       type: "success",
      //       message: res.data.msg,
      //     });
      //     this.$parent.getList();
      //     this.userOpenFlag = false;
      //   } else {
      //     this.$message({
      //       type: "error",
      //       message: res.data.msg,
      //     });
      //   }
      // });
    },
  },
  beforeCreate() {},
  created() {},
  mounted() {
    // this.list = this.states.map((item) => {
    //   return { value: `value:${item}`, label: `label:${item}` };
    // });
  },
};
</script>

<style lang="scss" scoped>
.addCheck {
  /deep/.el-drawer__body {
    position: relative;
  }

  .demo-drawer__footer {
    position: absolute;
    bottom: 10px;
    right: 10px;
  }
}
</style>